export const SESSION_TOKEN_KEY = "@LIGHTHOUSE_BP/SESSION_TOKEN_KEY"
